module.exports = __webpack_public_path__ + "static/media/logo.7655957b.png";